const hackthonRouter = [
	// 首页
	{
		path: '/interview/index',
		name: 'hackthon-index',
		component: () => import('../views/hackathon/index'),
		meta: {
			isLogin: false
		}
	},
	{
        path: '/interview/list',
		name: 'hackathon-list',
		component: () => import('../views/hackathon/list'),
		meta: {
			isLogin: false
		}
    },
    {
        path: '/interview/detail',
		name: 'hackathon-detail',
		component: () => import('../views/hackathon/detail'),
		meta: {
			isLogin: false
		}
    },
    {
        path:'/interview/answer',
        name: 'hackathon-answer',
        component: () => import('../views/hackathon/answer'),
        meta:{
            isLogin: false
        }
    },
    {
        path:'/interview/my',
        name: 'hackathon-my',
        component: () => import('../views/hackathon/my'),
        meta:{
            isLogin: false
        }
    },
    { path:'/interview/result',
    name: 'hackathon-result',
    component: () => import('../views/hackathon/result'),
    meta:{
        isLogin: false
    }

    }
]

export default hackthonRouter
